<template>
  <div class="list">
    <div class="breadcrumb">
      <div class="breadcrumb">
        <Breadcrumb>
          <Breadcrumb-item>合同模板</Breadcrumb-item>
        </Breadcrumb>
      </div>
    </div>
    <Form>
      <Row>
        <Col :span="4">
          <Select v-model="formData.id" @on-change="onChange">
            <Option v-for="item in versionList" :value="item.id" :key="item.id">{{ item.title}}</Option>
          </Select>
        </Col>
        <Col :span="2">
          <Button type="primary" @click="onAdd(null,true)" :style="{ marginLeft: '10px', marginRight: '10px'}" >新增模版</Button>
        </Col>
        <Col :span="2">
          <Button type="primary" @click="onAdd(formData,false)" >修改模版名称</Button>
        </Col>
      </Row>
      <Row>
        <div style="color: red; line-height: 24px;">
          <p>
            合同中可以引用动态数据:
          </p>
          <p>
            学生订单合同：{学生ID},{订单编号},{付款金额},{付款金额大写},
            {课程有效期},{课时},{学生姓名英文},{学生姓名中文},{学生姓名中文繁体},{付款金额英文},{付款金额繁体}
          </p>
        <p>老师合同:{老师ID},{老师姓名},{合同开始时间},{合同结束时间},{签字时间}</p>
        </div>
      </Row>
    </Form>
   <Row>
     <quillEditor v-model="formData.contract" ref="myQuillEditor" :options="editorOption"
                  @change="textChange"></quillEditor>
   </Row>
    <div slot="footer" :style="{ marginTop: '10px' }">
      <Button type="primary" size="large" @click="openPreview" :style="{ marginLeft: '10px', marginRight: '10px'}">预览</Button>
      <Button type="primary" size="large" :loading="loadingInsert" @click="saveData">保存</Button>
    </div>
    <Modal title="新增/编辑" v-model="editModal">
      <Form ref="form" class="form" :model="formData" :label-width="80">
        <Row>
          <i-col :span="22">
            <Form-item label="名称" prop="title">
              <Input v-model="formData.title"></Input>
            </Form-item>
          </i-col>
          <i-col :span="11">
            <Form-item label="状态" prop="status">
              <Select v-model.number="formData.status">
                <Option v-for="item in $constant.enabledStatus" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="editModal=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingEdit" @click="saveData">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import * as Quill from 'quill'
import {quillEditor} from 'vue-quill-editor'

var fonts = ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial', 'Times-New-Roman', 'sans-serif']
var Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

export default {
  components: {
    quillEditor,
  },
  name: 'ContractVersion',
  data() {
    return {
      loadingInsert: false,
      reload: 0,
      editModal: false,
      loadingEdit: false,
      versionList: [],
      formData: {
        id: '',
        title: '',
        contract: '',
        status: 1,
      },
      editorOption: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{'header': 1}, {'header': 2}],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'indent': '-1'}, {'indent': '+1'}],
              [{'size': ['small', false, 'large', 'huge']}],
              [{'header': [1, 2, 3, 4, 5, 6, false]}],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              [{'font': fonts}],
              ['clean'],
              ['link', 'image', 'video']
            ],
          },
        }
      }
    }
  },
  mounted: function () {
    this.queryContract()
  },
  created: function () {
  },
  methods: {
    queryContract () {
      let self = this
      self.$http.post('/common/contractSelect', {
        pageSize: 1000,
        pageIndex: 1,
      }).then(function (res) {
        if (res && res.data) {
          self.versionList = res.data.data
        }
      })
    },
    onChange (val) {
      this.versionList.forEach(v => {
        if (v.id === val) {
          this.formData.contract = v.contract
          this.formData.title = v.title
        }
      })
    },
    openPreview () {
      const contract = this.$refs.myQuillEditor.quill.root.innerHTML
      let url = `https://test-h5.kouyujie.cn/contract/contract.html`
      if (this.$appConfig.active === 'prod') {
        url = `https://h5.speakstreet.cn/contract/contract.html`
      }
      const newWindow = window.open(url, '_blank')
      setTimeout(() => {
        newWindow.postMessage({type: 'SET_CONTENT', contract}, '*')
      }, 1000)
    },
    textChange(val) {
      this.formData.contract = val.html
    },
    saveData() {
      let self = this
      self.loadingInsert = true
      self.$http.post('/common/editContract', self.formData).then(function (res) {
        if (res && res.data > 0) {
          self.$Message.success('保存成功!')
        }
        self.loadingInsert = false
        self.editModal = false
        self.queryContract()
      }).catch(function (e) {
        console.log(e)
        self.loadingInsert = false
      })
    },
    onAdd (row,isAdd) {
      if (isAdd) {
        this.formData = {
          id: '',
          title: '',
          status: '',
        }
        this.editModal = true
        return
      }
      if (row.id === '') {
      this.$Message.warning('请选择合同模版!')
        return
      }
      this.formData.id = row.id
      this.formData.title = row.title
      this.formData.status = row.status
      this.editModal = true
    }
  },
}
</script>



// WEBPACK FOOTER //
// ContractVersion.vue?102d5cb7